<template>
	<el-dialog title="修改开始合作时间" :visible.sync="addVisible" :append-to-body="true" width="420px" :before-close="beforeClose">
		<div class="tips flex mb-20">
			<i class="iconfont mt-2 mr-6 icon-a-info-circlexinxi-mian yx-color-primary"></i>
			<p> 开始合作时间最多支持选择到30天前，系统将根据“开始合作时间”统计该商品的带货数据。 </p>
		</div>
		<el-form :model="editFrom" ref="editFrom" :rules="editRules">
			<el-form-item label="开始合作时间：" label-width="130px" prop="start_time">
				<el-date-picker v-model="timesTamp" type="datetime" @change="changeTimed" value-format="timestamp" placeholder="选择开始合作时间">
				</el-date-picker>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="beforeClose">取 消</el-button>
			<el-button type="primary" @click="editConfirm">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { updateStartTime } from '@/api/cooperationProgress';
export default {
	data() {
		return {
			addVisible: false,
			editFrom: {
				start_time: '',
			},
			editRules: {
				start_time: [{ required: true, message: '请填写开始合作时间', trigger: 'blur' }],
			},
			row: {},
			timesTamp: '',
		};
	},
	methods: {
		show(row) {
			this.row = row;
			this.addVisible = true;
		},
		changeTimed(val) {
			this.editFrom.start_time = val ? val / 1000 : 0;
		},
		editConfirm() {
			this.$refs.editFrom.validate(async valid => {
				if (valid) {
					this.editFrom.cooperate_id = this.row.cooperate_id;
					const { code } = await updateStartTime(this.editFrom);
					if (code !== 0) return;
					this.$emit('refreshList');
					this.$message.success('修改成功');
					this.beforeClose();
				}
			});
		},
		beforeClose() {
			this.timesTamp = '';
			this.editFrom = {
				start_time: '',
			};
			this.$refs['editFrom'].resetFields();
			this.addVisible = false;
		},
	},
};
</script>
<style lang="less" scoped>
</style>